import React, { Component } from 'react';
import { connect } from 'react-redux';
import { StaticQuery, graphql } from 'gatsby';
import * as routes from '../constants/routeNames';
import { toUpperCase } from '../constants/strings';
import { ParallaxBanner } from 'react-scroll-parallax';

const mapStateToProps = (state) => ({
	page: state.thadState.page
});
const mapDispatchToProps = (dispatch) => ({});

interface DispatchProps {}
interface StateProps {
	page: string;
}
interface OwnProps {}
type Props = DispatchProps & StateProps & OwnProps;
type State = {};

class Banner extends Component<Props, State> {
	constructor(props: Props) {
		super(props);
	}
	toUpperCase = (string: string) => {
		return string.replace(/\b\w/g, (l) => l.toUpperCase());
	};
	getTitle = (data: any) => {
		const page = this.props.page;
		const banner = (data.allContentfulBanner.edges as Array<any>).filter((edge) => edge.node.title === page);
		if (banner[0]) {
			return toUpperCase(banner[0].node.header as string);
		} else {
			return '';
		}
	};
	getAlt = (data: any) => {
		const page = this.props.page;
		const banner = (data.allContentfulBanner.edges as Array<any>).filter((edge) => edge.node.title === page);
		if (banner[0]) {
			return banner[0].node.alt;
		} else {
			return '';
		}
	};
	getImage = (data: any) => {
		const page = this.props.page;
		const banner = (data.allContentfulBanner.edges as Array<any>).filter((edge) => edge.node.title === page);
		if (banner[0]) {
			return banner[0].node.image.resolutions.src;
		} else {
			return '';
		}
	};
	render() {
		return (
			<StaticQuery
				query={graphql`
					query Banner {
						allContentfulBanner {
							edges {
								node {
									title
									alt
									header
									image {
										resolutions(width: 1920) {
											width
											height
											src
											srcSet
										}
									}
								}
							}
						}
					}
				`}
				render={(data) => (
					<React.Fragment>
						{this.props.page === routes.CONNECT ? (
							<div className='banner-connect uk-inline uk-width-expand'>
								<img
									className='banner-img uk-width-expand'
									width='1920'
									height='1080'
									alt={this.getAlt(data)}
									data-src={this.getImage(data)}
									data-uk-img
								/>
								<div className='uk-position-cover carousel-cover banner-connect' />
							</div>
						) : (
							<ParallaxBanner
								style={{ height: '300px', objectFit: 'center' }}
								layers={[
									{
										image: this.getImage(data),
										amount: 0.7,
										children: null
									}
								]}
							>
								<div className='uk-position-cover carousel-cover banner' />
								<div className='uk-position-cover banner uk-light'>
									<div className='uk-flex uk-flex-center uk-flex-middle banner'>
										<h2>{this.getTitle(data)}</h2>
									</div>
								</div>
							</ParallaxBanner>
						)}
					</React.Fragment>
				)}
			/>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Banner);

{
	/* <div className='banner uk-inline uk-width-expand'>
	<img
		className='banner-img uk-width-expand'
		width='1920'
		height='1080'
		alt={this.getAlt(data)}
		data-src={this.getImage(data)}
		data-uk-img
	/>
	<div className='uk-position-cover carousel-cover banner' />
	<div className='uk-position-cover banner uk-light'>
		<div className='uk-flex uk-flex-center uk-flex-middle banner'>
			<h2>{this.getTitle(data)}</h2>
		</div>
	</div>
</div> */
}
